import React from "react";
import Layout from "./../components/Layout/Layout";

const Policy = () => {
  return (
    <Layout title={"Privacy Policy"}>
      <div className="row contactus ">
        <div className="col-md-6 ">
          <img
            src="/images/contactus.jpeg"
            alt="contactus"
            style={{ width: "100%" }}
          />
        </div>
        <div className="col-md-4">
          <p className="fw-bold fs-5" >According to our privacy policy: </p>
          <p></p>
          <p>1. Data Security</p>
          <p>2. Data Privacy</p>
          <p>3. Refund in case of bad product</p>
        </div>
      </div>
    </Layout>
  );
};

export default Policy;
